<template>
    <div class="mt-2">
        <div id="personTable">
            <v-toolbar
                class="elevation-1 white--text"
                color="primary"
                height="50px"
            >
                <v-toolbar-title>
                    <v-icon class="white--text">
                        fa-user-alt
                    </v-icon>
                    Personnel
                </v-toolbar-title>
                <v-divider
                    class="mx-2"
                    inset
                    vertical
                />
                <v-spacer />
                <v-btn
                    class="info text--white"
                    to="/manage-personnel/add-person"
                >
                    Add Person
                </v-btn>
            </v-toolbar>
            <v-data-table
                :headers="headers"
                :items="personnelListForTable"
                :items-per-page="10"
                class="elevation-1"
                fixed-header
            >
                <template
                    slot="item"
                    slot-scope="props"
                >
                    <tr>
                        <td class="text-xs-left">
                            <router-link
                                :to="{ name: 'manage person', params: { personId: props.item.personId }}"
                                class="managePersonLink"
                            >
                                {{ props.item.name }}
                            </router-link>
                        </td>
                        <td class="text-xs-left">
                            <p
                                class="mb-0"
                                v-if="props.item.jobName && props.item.jobName.length !== 0"
                            >
                                {{ props.item.jobName }}
                            </p>
                            <p
                                class="mb-0"
                                v-else
                            >
                                No current employment
                            </p>
                        </td>
                        <td class="text-xs-left">
                            <div>
                                <p class="mb-0">
                                    {{ props.item.isLive == 1 ? 'Yes' : 'No' }}
                                </p>
                            </div>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    // import {FETCH_JOB_LIST} from "@/store/job/actions";
    // import {FETCH_PERSONNEL_COUNTRY_LIST} from "@/store/personnel_country/actions.js";
    import { FETCH_PERSONNEL } from "../../../store/person/actions";

    export default {
        name: "PersonnelTable",

        data() {
            return {
                headers: [
                    {
                        text: 'Name',
                        align: 'left',
                        value: 'name',

                    },
                    {text: 'Job', value: 'jobName', width: '33%',},
                    {text: 'Live', value: 'isLive', width: '33%',},
                ],
            }
        },

        computed: {
            ...mapGetters(["personnelListForTable", "departmentNameById", "getJobNameById", "getCurrentEmploymentForPerson"])
        },

        mounted() {
            this.getPersonnelList();
        },

        methods: {
            // getPersonnelCountryList() {
            //     this.$store.dispatch(FETCH_PERSONNEL_COUNTRY_LIST);
            // },
            // getJobList() {
            //     this.$store.dispatch(FETCH_JOB_LIST);
            // },
            getPersonnelList() {
                this.$store.dispatch(FETCH_PERSONNEL);
            },
            // teamNameById(teamId) {
            //     return this.$store.getters.teamNameById(teamId);
            // },
        },
    }
</script>

<style scoped>
    #personnelTable p {
        font-size: 14px;
    }
</style>
